import React, {useState, useEffect} from 'react';
import {Link as RouterLink, useHistory } from 'react-router-dom';
import {Link} from '@mui/material';
import {Button, Grid, Container, Box} from '@mui/material'
import {UserService} from '../../../services';
import CustomDataGrid
 from '../../../customUtil/DataGrid';
 import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import moment from 'moment';
const columns = [
    {
        field: 'username', headerName: 'User Name', width: 230,
        renderCell: (params) => (
            <Link component={RouterLink} to={'/admin/user/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'email', headerName: 'Email', width: 230},
    {field: 'enabled', headerName: 'Is Active', width: 100},
    {field: 'lastLogin', headerName: 'Last Login', width: 250,  valueFormatter: params => 
   params.value ? moment(params?.value).format("DD/MM/YYYY hh:mm A") : '',},
    {field: 'userAssignedRoles', headerName: 'Assigned Roles', width: 400,
    renderCell: (params) => (
        <>{params.value.toString().replaceAll(",", ",  ")}</>
    )
    }
]



const UserManagement = () => {
        const [list, setList] = useState([]);
        const history = useHistory();
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            UserService.getAll()
                .then((response) => {
                    setList(response.data);
                    setLoading(false);
                });
        }, []);

        return (
            <React.Fragment>
                <Container>
                <header>
                    <h1>Users</h1>
                </header>
                    <Grid container spacing={2}>                    
                        <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/admin/user/new')}}>Create New</Button>
                        </Grid>  
                        <Grid item xs={12}>
                        <Box >
                            <DataGrid 
                             autoHeight
                            rows={list}
                            columns={columns}
                            slots={{ toolbar: GridToolbar }}
                            loading={loading}
                            getRowHeight={() => 'auto'}
                            sx={{
                              [`& .${gridClasses.cell}`]: {
                                py: 2,
                              },
                            }}
                            slotProps={{
                                toolbar: {
                                 showQuickFilter: true ,
                                 quickFilterProps: { debounceMs: 600 },
                                         },
                              }}
                            />                           
                            </Box>
                        </Grid>
                    </Grid>
                  </Container>
            </React.Fragment>
        );
    }
;

export default UserManagement;
